import React from 'react'
import './home.css'
import MyThree from '../components/MyThree';




function home() {
  return (
    <>
    <MyThree/>
    <svg className="curvebby" width="1900" height="600">
        <path id="curve" d="M 0 370 Q 970 129, 1920 370"></path>
        <text className="text">
            <textPath className="textPath" href="#curve" startOffset="9%">
                MUAAZ ABED
            </textPath>
        </text>
    </svg>
    <p className='bio'>Computing enthusiast and writer</p>
    <img src='https://assets-v2.lottiefiles.com/a/d7cd2632-1188-11ee-8742-c3b83f8190e7/bewzNgv6iS.gif' className='scroll'></img>

    <div className='aboutbox'>
      <h1 className='about'>About Me</h1>
      <p className='aboutstuff'>Hello! I'm Muaaz Abed, a software <br></br>developer from Texas with several <br></br>years of experience developing <br></br> full-stack applications.<br></br><br></br>I am currently a college junior <br></br> in Computer Science with a <br></br> minor in Literature at the<br></br>University of Texas at<br></br>Dallas.</p>
      <div className='flex'>
      <a href="https://github.com/muaazabed" target="_blank" 
        rel="noopener noreferrer"> 
        <img id="logo" src=
            "https://img.icons8.com/ios11/512/FFFFFF/github.png" 
            alt="Github">
        </img>
      </a>
      <a href="https://www.linkedin.com/in/muaaz-abed" target="_blank" 
        rel="noopener noreferrer"> 
        <img id="logo" src=
            "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/linkedin-app-white-icon.png" 
            alt="LinkedIn">
        </img>
      </a>
      </div>
    </div>
    <h1 className='end'>.</h1>
    </>
  )  
}

export default home